<template>
  <!-- https://www.amuletj.com/ -->
  <div class="container">
    <div class="nav block">
      <img class="logo-img" src="@assets/amuletj/logo.png" alt="logo" />
      <div class="nav-item">首页</div>
    </div>

    <img class="img" src="@assets/amuletj/top.png" alt="">

    <div class="block-title">商品信息展示</div>
    <div class="block">
      <img class="img block-img " src="@assets/amuletj/goods-info.png" alt="">
    </div>

    <div class="block-title">购物流程</div>
    <div class="block">
      <img class="img block-img " src="@assets/amuletj/shop-flow.png" alt="">
    </div>

    <div class="block-title">6000+合作品牌</div>
    <div class="brand">
      <div class="swiper">
        <div class="swiper-container">
          <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="@assets/promotion/brand-1.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="@assets/promotion/brand-2.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="@assets/promotion/brand-3.png" alt="" />
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
        </div>
      </div>
    </div>

    <div class="footer">
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2020106660号-2</a>
    </div>

  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.css'

export default {
  created() {
    document.title = '商品推荐'
  },
  destroyed() {
    document.title = '唯代购-唯品会旗下专业代购批发平台'
  },
  mounted() {
    window.addEventListener('scroll', this.scroll, true)
    setTimeout(() => {
      let mySwiper = new Swiper('.swiper-container', {
        direction: 'horizontal', //滑动方向，可设置水平(horizontal)或垂直(vertical)。
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        paginationClickable: true,
        observer: true,
        observeParents: true
      })
    }, 500)
  },
}
</script>

<style lang="stylus" scoped>
.container {
  width: 100%;
  min-width: 1000px;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;

  .block {
    width: 68.5%;
    min-width: 900px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .nav {
    display: flex;
    align-items: center;
    height: 70px;
  }
  .logo-img {
    width: 73px;
    height: 56px;
    cursor: pointer;
  }
  .nav-item {
    margin-left: 20px;
    width: 120px;
    height: 69px;
    line-height: 69px;
    box-sizing: border-box;
    text-align: center;
    color: #F8100E;
    font-size: 24px;
    border-bottom: 4px solid #F8100E;
    cursor: pointer;
  }

  .block-title {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    font-size: 36px;
    background: linear-gradient(270deg, #FFFFFF 0%, #F5F5F5 50%, #FFFFFF 100%);
  }

  .img {
    width: 100%;
    height: auto;
  }

  .block-img {
    margin-top: 40px;
    margin-bottom: 80px;
  }

  .brand {
    width: 800px;
    height: 370px;
    margin: 40px auto 40px;
  }
  .swiper {
    width: 100%;
    height: 100%;
    z-index: 9;
    .swiper-container {
      width: 100%;
      height: 100%;
      /deep/ .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
      }
      /deep/ .swiper-pagination-bullet-active {
        background: #DD2628;
      }
    }
    img {
      width: 100%;
      height: 308px;
    }
  }

  .footer {
    width: 100%;
    height: 130px;
    background: #F5F5F5;
    text-align: center;
    padding-top: 40px;
    color: #666;
    font-size: 24px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/amuletj.vue